import React from 'react'
import styles from './Tag.module.scss'
import { Tooltip } from 'antd'

interface ITagProps {
  data: any
  className?: string
}

const Tag: React.FC<ITagProps> = ({ data = [], className = '' }) => {
  const tagsToShow = data.slice(0, 4)
  const nameArray = data.slice(4).reduce((acc: any, { name }: any) => acc.concat(<div key={name}>{name}</div>), [])
  return (
    <React.Fragment>
      {tagsToShow.map(({ name, color }: any, index: number) => (
        <div className={`rankmiTable-tag ${styles.tagContainer} ${className}`} key={`tag-${index}`} style={{ background: `${color}40` }}>
          {name}
        </div>
      ))}
      {data.length > 4 && (
        <Tooltip placement="top" title={nameArray}>
          <div className={`rankmiTable-tag-tooltip ${styles.tagContainer} ${className}`} style={{ background: `#aaa9a940` }}>
            {`+${data.length - 4}`}
          </div>
        </Tooltip>
      )}
    </React.Fragment>
  )
}

export default Tag
